import { useEffect, useState } from "react";
import allRoutes from "../../routes/sidebar";
import { NavLink, useLocation } from "react-router-dom";
import * as Icons from "../../assets/icons";
import SidebarSubmenu from "./SidebarSubmenu";
import { useSelector } from "react-redux";
import ChangeTheme from "../Header/components/ChangeTheme";
import SearchStockHolders from "../Header/components/SearchStockHolders";
import SettingsMenu from "../Header/components/SettingsMenu";
import ExitComponent from "../Header/components/ExitComponent";
import ProfileMenu from "../Header/components/ProfileMenu";
import NotificationsMenu from "../Header/components/NotificationsMenu";
import CreditComponent from "../Header/components/CreditComponent";
import Tooltip from "../ToolTip";
import { AnimatePresence, motion } from "framer-motion";
import { BASE_URL } from "../../api/ApiConstants";
import { isMobile } from "react-device-detect";

const packageJson = require("../../../package.json");

function Icon({ icon, ...props }) {
  const Icon = Icons[icon];
  return <Icon {...props} />;
}

function SidebarContent() {
  const [routes, setRoutes] = useState(allRoutes);
  const hasPermission = useSelector(
    (state) => state?.data?.Permission?.JustCreateStockRightPaper
  );
  const { pathname } = useLocation();
  const [open, setOpen] = useState("");

  const handleDropdownMenuClick = (name) => {
    if (open === name) {
      setOpen("");
    } else {
      setOpen(name);
    }
  };
  const summary = useSelector((state) => state["data"].Summary);
  const theme = useSelector((state) => state?.theme?.mode);

  useEffect(() => {
    if (hasPermission) {
      setRoutes(routes.filter((item) => item.name === "حق تقدم"));
    }

    if (
      BASE_URL.includes("https://st2api.hbbs.ir/") ||
      BASE_URL.includes("http://api.test.hamrahbours.ir/") ||
      BASE_URL.includes("http://apitest.hamrahbours.ir/")
    ) {
      const reportRoute = {
        icon: "MdOutlineAddchart",
        name: "حق تقدم استفاده نشده",
        routes: [
          {
            path: "/createReport",
            name: "ساخت گزارش حق تقدم استفاده نشده",
          },
          {
            path: "/previousReports",
            name: "گزارش های پیشین",
          },
        ],
      };

      const smsRoute = {
        icon: "FaCommentSms",
        name: "اس ام اس",
        routes: [
          {
            path: "/sendsms",
            name: "ارسال اس ام اس",
          },
          {
            path: "/smshistory",
            name: "گزارش اس ام اس های ارسالی",
          },
        ],
      };

      const updatedRoutes = [...routes];
      updatedRoutes.splice(4, 0, reportRoute);
      updatedRoutes.splice(6, 0, smsRoute);
      setRoutes(updatedRoutes);
    }
  }, []);

  return (
    <div className="text-gray-500 h-full dark:text-gray-400">
      <div className="flex items-center justify-around py-4">
        <div className="flex items-center justify-center text-lg font-bold text-brand dark:bg-white">
          <Icons.LogoMinIcon className="w-8 h-8 ml-1" />
          <h1 className="mt-1">همراه بورس</h1>
        </div>
        {isMobile && (
          <div className="flex items-center justify-center gap-x-3 transform scale-110 z-[5000]">
            <SearchStockHolders />
            <SettingsMenu />
            <NotificationsMenu />
            <ProfileMenu />
            <ChangeTheme />
            <ExitComponent />
          </div>
        )}
      </div>
      <ul className="pb-4 relative">
        {routes.map((route) =>
          route.routes ? (
            <SidebarSubmenu
              open={open}
              handleDropdownMenuClick={handleDropdownMenuClick}
              summary={summary}
              pathname={pathname}
              route={route}
              key={route.name}
            />
          ) : (
            <li className="px-6 py-2 text-xs" key={route.name}>
              <NavLink
                to={route.path}
                className={(navData) =>
                  navData.isActive
                    ? "bg-brand dark:text-white pointer-events-none text-white rounded-md p-2 inline-flex items-center w-full text-sm font-semibold transition-colors duration-150"
                    : "bg-solid hover:opacity-80 rounded-md p-2 inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 text-title"
                }
              >
                <AnimatePresence>
                  {pathname === route.path && (
                    <motion.span
                      initial={{ height: 0 }}
                      animate={{ height: "36px" }}
                      exit={{ height: 0 }}
                      className="absolute h-12 right-0 w-1.5 bg-brand rounded-l-lg"
                      aria-hidden="true"
                    />
                  )}
                </AnimatePresence>
                <Icon
                  className={`w-5 h-5 ml-2.5 transform scale-110 text-brand dark:text-white ${
                    theme === "dark" && pathname === route.path ? "" : "icon"
                  }`}
                  aria-hidden="true"
                  style={{
                    filter: `${
                      pathname === route.path && theme === "light"
                        ? "brightness(500)"
                        : ""
                    }`,
                  }}
                  icon={route.icon}
                />
                <span className="inline-flex gap-x-2.5 items-center">
                  <span className="mt-1 text-xs">{route.name}</span>
                  {summary?.MessageCount > 0 &&
                    route.path === "/messageBetter" && (
                      <span className="flex h-3 w-3 relative ">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-600 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-rose-500"></span>
                      </span>
                    )}
                </span>
              </NavLink>
            </li>
          )
        )}
      </ul>
      <div className="pb-4 block sm:hidden">
        <CreditComponent />
      </div>
      {BASE_URL.includes("https://st2api.hbbs.ir/") ? (
        <Tooltip content="شما در حال استفاده از نسخه تستی هستید">
          <div className="pb-4 text-center font-semibold">
            نسخه <span className="text-sm">{packageJson.version}</span> تستی
          </div>
        </Tooltip>
      ) : (
        <div className="pb-4 text-center font-semibold">
          نسخه <span className="text-sm">{packageJson.version}</span>
        </div>
      )}
    </div>
  );
}

export default SidebarContent;
